/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroup
 */
export interface UserGroup {
    /**
     * 
     * @type {number}
     * @memberof UserGroup
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof UserGroup
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    imageId: string;
    /**
     * 
     * @type {number}
     * @memberof UserGroup
     */
    state: number;
}

/**
 * Check if a given object implements the UserGroup interface.
 */
export function instanceOfUserGroup(value: object): value is UserGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('imageId' in value) || value['imageId'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function UserGroupFromJSON(json: any): UserGroup {
    return UserGroupFromJSONTyped(json, false);
}

export function UserGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'date': (new Date(json['date'])),
        'imageId': json['imageId'],
        'state': json['state'],
    };
}

export function UserGroupToJSON(value?: UserGroup | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'date': ((value['date']).toISOString()),
        'imageId': value['imageId'],
        'state': value['state'],
    };
}

